[
  {
    "path": "/next_ai/default_images/yasa-design-studio-yRy67QL_CGI-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/pawel-czerwinski-YKwN7WUe4sM-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/mohamed-nohassi-VEYiT6cvafc-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/planet-volumes-Ld8fGry6NSM-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/christoffer-voss-OSnGmbS0I-c-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/jonathan-roger-LY1eyQMFeyo-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/sean-oulashin-KMn4VEeEPR8-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/getty-images--1vSQxDf0Xw-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/puzzle-creative-0MA5uwdiShE-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/eva-corbisier-WWPScKubfLk-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/zulfahmi-al-ridhawi-NjdC16HjL_c-unsplash.jpg"
  },
  {
    "path": "/next_ai/default_images/eva-corbisier-7xlJbjmpS68-unsplash.jpg"
  }
]
